// todo: remove after item.product has been added to contentful
export default {
  loan: 'consumer-loan',
  'personal-loan': 'consumer-loan',
  'house-loan': 'mortgage'
}
